import { Decoration } from '@atlaskit/editor-prosemirror/view';
import { getSelectedBlock } from '../utils';
import { filterDecorationByKey, ProactiveDecorations } from './index';
export var removeSelectedRecommendationDecoration = function removeSelectedRecommendationDecoration(_ref) {
  var decorationSet = _ref.decorationSet,
    pluginState = _ref.pluginState;
  return decorationSet.remove(filterDecorationByKey(ProactiveDecorations.RECOMMENDATION_SELECTED, decorationSet));
};
export var addSelectedRecommendationDecoration = function addSelectedRecommendationDecoration(_ref2) {
  var decorationSet = _ref2.decorationSet,
    tr = _ref2.tr,
    pluginState = _ref2.pluginState;
  var selection = tr.selection;
  if (selection.from === selection.to) {
    var _block$recommendation;
    var block = getSelectedBlock(pluginState, selection.to);
    if (!!(block !== null && block !== void 0 && (_block$recommendation = block.recommendations) !== null && _block$recommendation !== void 0 && _block$recommendation.length)) {
      var from = block.from,
        to = block.to;
      return decorationSet.add(tr.doc, [Decoration.inline(from, to, {
        class: "ai-proactive-recommendation-selected"
      }, {
        key: ProactiveDecorations.RECOMMENDATION_SELECTED
      })]);
    }
  }
  return decorationSet;
};